<section
  class="eventq-note-section"
  [class.eventq-note-section--loading]="loading()"
  [attr.aria-busy]="loading() ? true : null"
  [attr.aria-label]="loading() ? 'Loading note' : title()"
>
  @if (loading()) {
    <div class="eventq-note-section__skeleton" aria-hidden="true">
      <span class="eventq-note-section__skeleton-line eventq-note-section__skeleton-line--title"></span>
      <span class="eventq-note-section__skeleton-line eventq-note-section__skeleton-line--body"></span>
      <span
        class="eventq-note-section__skeleton-line eventq-note-section__skeleton-line--body-short"
      ></span>
    </div>
  } @else {
    <h3 class="eventq-note-section__title">{{ title() }}</h3>
    <div class="eventq-note-section__body-wrap">
      <p class="eventq-note-section__body">{{ body() }}</p>
    </div>
  }
</section>
